import { useEffect, useState } from "react";
import request from "project-config/services/request/request";
import { NotificationTabType, QueryApiConfig } from "../constants";
import { useNotificationStore } from "../store/notification-store";

export interface IBillingMessageInfoItem {
  billMonth: number;
  createTime: number;
  id: number;
  isRead: number;
  message?: string;
  messageExtend: string;
}
interface IBillingMessageInfo {
  total: number;
  pageCount: number;
  pageNum: number;
  size: number;
  items: IBillingMessageInfoItem[];
}

export function useInitNotification() {
  const initBillingData = {
    total: 0,
    pageCount: 1,
    pageNum: 1,
    size: 50,
    items: [],
  };
  const [billingMessage, setBillingMessage] =
    useState<IBillingMessageInfo>(initBillingData);

  const { currentNotificationTab, setNoReadNum, setTotalNum } =
    useNotificationStore();
  const fetchNotificationData = async (pageNum?: number) => {
    setBillingMessage(initBillingData);
    const config =
      currentNotificationTab === NotificationTabType.BillingMessage
        ? QueryApiConfig[NotificationTabType.BillingMessage]
        : QueryApiConfig[NotificationTabType.AppealBillingMessage];
    if (!config) return;
    const { data } = await request.post(
      config.queryApi,
      config.queryParams({
        pageSize: 50,
        pageNum: pageNum || 1,
      })
    );
    if (!data) return;
    setBillingMessage({ ...data });

    const { data: result } = await request.post(
      "/api/rendering/message/messageStatistics",
      config.queryStatisticsParams()
    );
    if (!result) return;
    const { billNotRead, taskNotRead, total } = result;
    setNoReadNum([billNotRead, taskNotRead]);
    setTotalNum(total);
  };

  useEffect(() => {
    fetchNotificationData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentNotificationTab]);

  return {
    setNoReadNum,
    billingMessage,
    setBillingMessage,
    fetchNotificationData,
  };
}
